import type { ReactNode } from 'react';
import { cn } from '@v2/design-system';

type Props = {
    title: ReactNode;
    icon?: ReactNode;
    children: ReactNode;
    className?: string;
    headerExtra?: ReactNode;
    /** Título numa linha; ações na linha de baixo (evita header apertado). */
    headerStacked?: boolean;
};

export default function DetailCard({ title, icon, children, className, headerExtra, headerStacked = false }: Props) {
    return (
        <section className={cn('flex h-full min-w-0 flex-col rounded-xl border border-gray-200 bg-white shadow-sm dark:border-zinc-700 dark:bg-zinc-900', className)}>
            <header
                className={cn(
                    'shrink-0 border-b border-gray-100 px-4 py-3 dark:border-zinc-800',
                    headerStacked
                        ? 'flex flex-col gap-2.5'
                        : 'flex items-center justify-between gap-3',
                )}
            >
                <div className="flex min-w-0 items-center gap-2">
                    {icon && <span className="shrink-0 text-gray-500 dark:text-zinc-400">{icon}</span>}
                    <h2 className="text-sm font-semibold text-gray-900 dark:text-zinc-100">{title}</h2>
                </div>
                {headerExtra && (
                    <div
                        className={cn(
                            headerStacked
                                ? 'flex w-full flex-wrap items-center gap-1.5'
                                : 'shrink-0',
                        )}
                    >
                        {headerExtra}
                    </div>
                )}
            </header>
            <div className="min-w-0 flex-1 overflow-x-hidden overflow-y-auto p-4 pb-5">{children}</div>
        </section>
    );
}
